// extracted by mini-css-extract-plugin
export var active = "TocDesktop-module--active--57b9c";
export var link = "TocDesktop-module--link--29ac0";
export var toc = "TocDesktop-module--toc--8b6e2";
export var tocDesktop = "TocDesktop-module--tocDesktop--6e779";